angular
	.module 'App.Module.ProductCategory', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'product_categories',
				url: '/categories',
				abstract: true
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
					'entity_search@product_categories':
						templateUrl: '@app/layout/views/app.entity-tree-search.view.html'
						controller: 'BaseTreeSearchController'
						controllerAs: 'search'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					treeItems: (ProductCategoryRepository) ->
						return ProductCategoryRepository.getEntities()
				data:
					searchParams:
						repositoryName: 'ProductCategoryRepository'
						title: 'general.categories'
					restrict: "Backoffice.TopMenu.Inventory.Categories"

			.state 'product_categories.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'

				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					category: (ProductCategoryRepository, $stateParams) ->
						return ProductCategoryRepository.getEntity($stateParams.id)

					productsList: (ProductRepository, $stateParams) ->
						if _.isEmpty($stateParams.id)
							return {count: 0, data: []}

						query = ProductRepository.createQuery()
						query.with 'product_categories'
						query.criteria 'product_categories.id', '=', $stateParams.id
						query.setPagination 0, ProductRepository.getPageSize()

						return ProductRepository.getEntitiesWithCount(query)

			.state 'product_categories.edit.details',
				url: '/details',
				views:
					"entity_sub_view":
						controller: 'ProductCategoryController'
						controllerAs: 'vm'
						templateUrl: '@app/product-category/product-category.view.html'
